import Api from '../../api/unlicensedCarOutIn'
import Dict from '../../api/dict'
export default {
  namespace: 'dict', // 注意定义namespace, 将会在store中存储
  state: {
    colorList: [{key: 0, value: '未知'}, {key: 1, value: '蓝色'}, {key: 2, value: '黄色'}, {key: 3, value: '白色'}, {key: 4, value: '黑色'}, {key: 5, value: '绿色'}],
    parklotList: [],
    channelList: [],
    plateTypeList: [],
    parklotIdDict: '',
    statusList: [{key: 1, value: '初始化'}, {key: 2, value: '未生效'}, {key: 3, value: '生效中'}, {key: 4, value: '已过期'}],
    couponsList: [],
    couponsIndex: [],
    listParklotsData: [],
    judgeList: [{key: 1, value: '是'}, {key: 2, value: '否'}]
  },
  getters: {
    colorList: state => state.colorList,
    parklotList: state => state.parklotList,
    channelList: state => state.channelList,
    plateTypeList: state => state.plateTypeList,
    statusList: state => state.statusList,
    couponsList: state => state.couponsList,
    couponsIndex: state => state.couponsIndex,
    listParklotsData: state => state.listParklotsData,
    judgeList: state => state.judgeList
  },
  actions: {
    // 获取用户全部停过的停车场
    getListParklotsAction ({commit, state}, account) {
      let obj = {
        account: account
      }
      commit('getlistParklotsDataMutations', [])
      Api.listParklots(obj).then((res) => {
        if (res.status === 200) {
          let data = res.data
          let arr = []
          data.forEach((item, index) => {
            let obj = {
              key: item.payParkId,
              value: item.payParkName
            }
            arr.push(obj)
          })
          commit('getlistParklotsDataMutations', arr)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取停车场
    getParklotListActions ({commit, state}) {
      commit('getParklotListMutations', [])
      Api.parklotList().then((res) => {
        if (res.status === 200) {
          let data = res.result
          let arr = []
          data.forEach((item, index) => {
            let obj = {
              key: item.id,
              value: item.name
            }
            arr.push(obj)
          })
          commit('getParklotListMutations', arr)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取通道
    getChannelListActions ({commit, state}, id) {
      let data = {
        'parklotId': id.parklotId,
        'outinType': id.outinType
      }
      commit('getChannelListMutations', [])
      Api.channelList(JSON.stringify(data)).then((res) => {
        if (res.status === 200) {
          let data = res.data
          let arr = []
          data.forEach((item, index) => {
            let obj = {
              key: item.id,
              value: item.name
            }
            arr.push(obj)
          })
          commit('getChannelListMutations', arr)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取车辆类型
    getPlateTypeListActions ({commit, state}, id) {
      let data = 'PLATE_TYPE'
      commit('getPlateTypeListMutations', [])
      Dict.getDicts(data).then((res) => {
        if (res) {
          let data = res
          let arr = []
          data.forEach((item, index) => {
            let obj = {
              'key': parseInt(item.dictValue),
              'value': item.dictName
            }
            arr.push(obj)
          })
          commit('getPlateTypeListMutations', arr)
        }
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  mutations: {
    getPayParams (state, value) {
      state.payParams = value
    },
    getOpenId (state, value) {
      state.openId = value
    },
    getParklotListMutations (state, value) {
      state.parklotList = value
    },
    getChannelListMutations (state, value) {
      state.channelList = value
    },
    getPlateTypeListMutations (state, value) {
      state.plateTypeList = value
    },
    getCouponsListMutations (state, value) {
      state.couponsList = value
    },
    getCouponsIndexMutations (state, value) {
      state.couponsIndex = value
    },
    getlistParklotsDataMutations (state, value) {
      state.listParklotsData = value
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dict.js